import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { nanoid } from 'nanoid'
import { Box, Image, Flex, Button } from 'theme-ui'

import HeroContent from 'gatsby-theme-minimal/src/components/Hero/heroComponents/HeroContentNoIndex'
import Shout from 'gatsby-theme-minimal/src/components/Shout/v1/Index'
import fetchGallery from 'gatsby-theme-minimal/src/helpers/fetchGallery'
import ImageSelector from 'gatsby-theme-minimal/src/components/Images/ImageSelector'
import componentOptionsSelector from 'gatsby-theme-minimal/src/helpers/componentOptionsSelector'

export default function Hero(props) {
  // ====================================
  // =========== Destructing ============
  // ====================================
  const {
    options,
    locationIndex,
    // locations,
    businessData,
    // configData,
    allGeneral,
    poweredImages,
    variantName,
    isMultiLocationSite,
    shoutData,
    gonationID
  } = props

  const storyId = options.storyId?.[locationIndex]
  const storyTag = options.storyTag?.[locationIndex]

  const {
    logoHero,
    titles,
    subtitles,
    texts,
    textType,
    ctaLinks,
    ctaNames,
    images,
    displayAlbums,
    interval,
    speed,
    autoplay,
    slidedots,
    containerStyles,
    shoutContainerStyles
  } = componentOptionsSelector(options, locationIndex, storyId, allGeneral, storyTag)

  const {
    // cover: { imageBaseUrl, imagePrefix },
    avatar: { imageBaseUrl: logoBaseUrl, imagePrefix: logoPrefix },
    // name,
    // street,
    desc,
    city
    // state,
    // zip,
    // phone,
  } = businessData

  // ====================================
  // ========== Component State =========
  // ====================================

  const [gallery, setGallery] = useState(null)

  // ====================================
  // ===== Variable Transformations =====
  // ====================================

  const NextArrow = ({ currentSlide, slideCount, ...props }) => <FontAwesomeIcon {...props} icon={faChevronRight} />

  const PrevArrow = ({ currentSlide, slideCount, ...props }) => <FontAwesomeIcon {...props} icon={faChevronLeft} />

  const settings = {
    dots: slidedots ? slidedots : true,
    infinite: true,
    arrows: true,
    autoplay: autoplay ? autoplay : true,
    speed: speed ? speed : 1500,
    autoplaySpeed: interval ? interval : 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    pauseOnHover: false
  }

  const styles = containerStyles ? JSON.parse(containerStyles) : {}
  const shoutStyles = shoutContainerStyles ? JSON.parse(shoutContainerStyles) : {}

  // ====================================
  // ========= async requests ===========
  // ====================================

  const fetchData = async (gonationID, displayAlbums) => {
    const data = await fetchGallery(gonationID, displayAlbums)
    setGallery(data[0])
  }

  useEffect(() => {
    if (displayAlbums) {
      fetchData(gonationID, displayAlbums[locationIndex])
    }
    return () => {}
  }, [])

  return (
    <>
      <Box variant={`${variantName}.hero`} sx={styles}>
        <HeroContent
          titles={titles}
          subtitles={subtitles}
          texts={texts}
          textType={textType}
          desc={desc}
          ctaNames={ctaNames}
          ctaLinks={ctaLinks}
          locationIndex={locationIndex}
          logoHero={logoHero}
          city={city}
          variantName={variantName}
          imageBaseUrl={logoBaseUrl}
          imagePrefix={logoPrefix}
          isMultiLocationSite={isMultiLocationSite}
        />
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            width: '100%',
            bottom: 334,
            zIndex: 99
          }}
        >
          <Flex sx={{ justifyContent: 'center', maxWidth: 400, margin: 'auto' }}>
            <Box sx={{ px: 2, flex: 1, width: '50%' }}>
              <Link to="/menu" style={{ display: 'block', width: '100%' }}>
                <Button sx={{ width: '100%', paddingX: '1rem' }}>Menu</Button>
              </Link>
            </Box>
            <Box sx={{ px: 2, flex: 1, width: '50%' }}>
              <a
                href="https://slicelife.com/restaurants/ct/bridgeport/06604/bank-sports-bar/menu"
                target={'_blank'}
                rel="noopener"
                style={{ display: 'block', width: '100%' }}
              >
                <Button sx={{ width: '100%', paddingX: '1rem' }}>Order Online</Button>
              </a>
            </Box>
          </Flex>
        </Box>

        {/* if the gallery has loaded use that if not then use the images provided in options else use nothing */}
        {gallery ? (
          <Slider {...settings} key={nanoid()}>
            {gallery.photos.map(image => (
              <Image key={nanoid()} src={image.imageUrl} alt="Cloudinary_Image" />
            ))}
          </Slider>
        ) : images ? (
          <Slider {...settings} key={nanoid()}>
            {images.map(image => (
              <ImageSelector
                key={nanoid()}
                image={image} // image from config
                poweredImages={props.poweredImages} // powered iamges object
                locationIndex={locationIndex}
              />
            ))}
          </Slider>
        ) : (
          ''
        )}
        {shoutData?.shout && (
          <Box
            variant={`${variantName}.shoutWidgetContainer`}
            className="shoutWidgetContainer"
            sx={{
              ...shoutStyles
            }}
          >
            <Shout
              shoutData={shoutData}
              // variantName={`${variantName}.shoutWidget`}
              className="shoutWidget"
            />
          </Box>
        )}
      </Box>
    </>
  )
}
